const styles = {
    dropzone: {
        border: "2px dashed #bbb",
        borderRadius: "12px",
        padding: "24px",
        textAlign: "center",
        cursor: "pointer",
        background: "#fafafa",
        marginBottom: "20px",
        transition: "background 0.3s ease",
    },
    thumbsContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        gap: "16px",
        marginTop: "16px",
    },
    thumb: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "140px",
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        padding: "12px",
        background: "#ffffff",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.06)",
        transition: "box-shadow 0.2s ease",
    },
    topRightRemoveBtn: {
        position: "absolute",
        top: "6px",
        right: "6px",
        background: "#e74c3c",
        border: "none",
        borderRadius: "50%",
        width: "24px",
        height: "24px",
        color: "#fff",
        fontSize: "16px",
        cursor: "pointer",
        lineHeight: "1",
    },
    thumbImage: {
        width: "100%",
        height: "100px",
        objectFit: "cover",
        borderRadius: "6px",
    },
    pdfPreview: {
        width: "100%",
        height: "100px",
        background: "#f0f0f0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "48px",
        borderRadius: "6px",
        color: "#6c757d",
    },
    fileName: {
        fontSize: "13px",
        textAlign: "center",
        wordBreak: "break-word",
        margin: "4px 0 0",
    },
    uploadBtn: {
        backgroundColor: "#007bff",
        color: "#fff",
        padding: "6px 12px",
        borderRadius: "5px",
        border: "none",
        fontSize: "13px",
        cursor: "pointer",
    },
    success: {
        color: "green",
        fontSize: "13px",
    },
    error: {
        color: "red",
        fontSize: "13px",
    },
    removeAllBtn: {
        marginTop: "12px",
        backgroundColor: "#d9534f",
        color: "#fff",
        padding: "10px 18px",
        borderRadius: "8px",
        border: "none",
        fontSize: "14px",
        cursor: "pointer",
    },
    status: {
        marginTop: "4px",
        fontSize: "13px",
        color: "#444",
    },
    footer: {
        textAlign: "center",
        marginTop: "20px",
    },
    emptyState: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 0",
        textAlign: "center",
        color: "#999"
    }
};

export default styles;